var CartEmpty, CartItems, CartSpinner, CartWidget, I18n, ref,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

I18n = require('../../../node_modules/grapefruit/lib/I18n');

window.I18n = new I18n();

require('../../../core/frontend/groupon_modules/groupon');

ref = require('../../client_templates'), CartItems = ref.CartItems, CartEmpty = ref.CartEmpty, CartSpinner = ref.CartSpinner;

module.exports = CartWidget = (function() {
  function CartWidget(el) {
    var ref1, ref2;
    this.el = el;
    this.renderCartData = bind(this.renderCartData, this);
    this.onComplete = bind(this.onComplete, this);
    this.fetchCartData = bind(this.fetchCartData, this);
    this.$el = $(this.el);
    this.useCartSizeEndpoint = typeof Groupon !== "undefined" && Groupon !== null ? (ref1 = Groupon.LS) != null ? (ref2 = ref1.flags) != null ? ref2.useCartSizeEndpoint : void 0 : void 0 : void 0;
    this.snickerdoodle = Cookie.get('snickerdoodle');
    if (this.$el.length) {
      this.fetch();
    }
  }

  CartWidget.prototype.fetch = function() {
    var complete, data, ref1, ref2, url;
    complete = this.onComplete;
    data = this.snickerdoodle ? {
      consumerId: this.snickerdoodle
    } : void 0;
    if (this.useCartSizeEndpoint) {
      url = ((ref1 = Groupon.endpoints) != null ? ref1.cartSize : void 0) || '/cart/size';
      this.$el.one('mouseover', this.fetchCartData);
    } else {
      url = ((ref2 = Groupon.endpoints) != null ? ref2.cart : void 0) || '/cart/widget';
    }
    return $.ajax({
      type: "GET",
      url: url,
      data: data,
      complete: complete
    });
  };

  CartWidget.prototype.fetchCartData = function() {
    var complete, data, ref1, translations;
    translations = Groupon.LS.translations.cart;
    this.$el.append(CartSpinner.render({
      translations: translations
    }));
    complete = this.renderCartData;
    data = this.snickerdoodle ? {
      consumerId: this.snickerdoodle
    } : void 0;
    return $.ajax({
      type: "GET",
      url: ((ref1 = Groupon.endpoints) != null ? ref1.cart : void 0) || '/cart/widget',
      data: data,
      complete: complete
    });
  };

  CartWidget.prototype.onComplete = function(data, textStatus, xhr) {
    var $cartFlyout, hasCart, hasError, response, responseText, showCheckout, translations;
    responseText = data.responseText;
    translations = Groupon.LS.translations.cart;
    showCheckout = Groupon.Cart.showCheckout;
    if (textStatus === 'success') {
      response = JSON.parse(responseText);
      hasError = response.hasError, hasCart = response.hasCart;
      if (!hasError) {
        if (hasCart) {
          this.showCart({
            response: response,
            translations: translations,
            showCheckout: showCheckout
          });
        } else {
          if (!this.useCartSizeEndpoint) {
            this.showEmptyCart({
              translations: translations
            });
          }
        }
        if (Groupon.LS.hasTouch) {
          $cartFlyout = $('.cart-flyout');
          this.$el.find('.icon-goods').on('tap', function(e) {
            e.preventDefault();
            e.stopImmediatePropagation();
            $cartFlyout.toggle();
            $('html').trigger('tap');
            if ($cartFlyout.is(':visible')) {
              return $('html').one('tap', function(e) {
                if ($(e.target).closest('#ls-header-cart-link').length === 0) {
                  return $cartFlyout.hide().attr('aria-hidden', 'true');
                }
              });
            }
          });
        }
      }
    }
    this.$el.addClass('cart-widget-shows');
    return delete window.CartWidget;
  };

  CartWidget.prototype.showCart = function(data) {
    this.renderCartLink(data);
    if (!this.useCartSizeEndpoint) {
      return this.$el.append(CartItems.render(data));
    }
  };

  CartWidget.prototype.renderCartLink = function(data) {
    var markup, quantity, quantity_value, ref1, translations;
    ref1 = data.response, quantity_value = ref1.quantity_value, quantity = ref1.quantity;
    translations = data.translations;
    markup = "<span class='cart-text'>" + translations.cart.desc + " (" + quantity + ")</span>\n<span class='cart-count'>" + quantity_value + "</span>";
    return this.$el.find('.icon-goods, a').html(markup);
  };

  CartWidget.prototype.renderCartData = function(data, textStatus, xhr) {
    var hasCart, hasError, response, responseText, showCheckout, translations;
    responseText = data.responseText;
    translations = Groupon.LS.translations.cart;
    showCheckout = Groupon.Cart.showCheckout;
    this.$spinnerFlyout = this.$el.find('.cart-flyout.load-spinner');
    if (textStatus === 'success') {
      response = JSON.parse(responseText);
      hasError = response.hasError, hasCart = response.hasCart;
      if (!hasError) {
        this.$spinnerFlyout.remove();
        if (hasCart) {
          this.renderCartLink({
            response: response,
            translations: translations
          });
          return this.$el.append(CartItems.render({
            response: response,
            translations: translations,
            showCheckout: showCheckout
          }));
        } else {
          return this.showEmptyCart({
            translations: translations
          });
        }
      } else {
        return this.$spinnerFlyout.addClass('ls-widget-error').html(translations.cart.cart_error);
      }
    } else {
      return this.$spinnerFlyout.addClass('ls-widget-error').html(translations.cart.cart_error);
    }
  };

  CartWidget.prototype.showEmptyCart = function(data) {
    this.$el.append(CartEmpty.render(data));
    if (this.useCartSizeEndpoint) {
      return this.$el.find('#ls-cart-link').html(data.translations.cart.cart);
    }
  };

  return CartWidget;

})();

